<template>
    <div
        class="chat-assistent-interaction-item"
    >
        <div class="chat-assistent-interaction-item__content-container">
            <div
                :class="{
                    'chat-assistent-interaction-item__content': true,
                    'chat-assistent-interaction-item__content--heyloha': hasHeylohaBranding(),
                }"
            >
                <bar-skeleton
                    v-for="i in props.messagesCount"
                    :key="i"
                    :width="Math.floor(Math.random() * (maxWidth - minWidth + 1)) + minWidth"
                    :height="18"
                />
            </div>
            <div class="chat-assistent-interaction-item__avatar">
                <div class="chat-assistent-interaction-item__avatar__skeleton" />
            </div>
        </div>
        <div class="chat-assistent-interaction-item__footer">
            <bar-skeleton :width="60" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import useAppBranding from '@/services/app-branding/composables/useAppBranding';

    const props = defineProps<{
        messagesCount: number,
    }>();

    const { hasHeylohaBranding } = useAppBranding();

    const minWidth = 100;
    const maxWidth = 400;
</script>

<style scoped lang="scss">
.chat-assistent-interaction-item {
    max-width: 80%;
    display: flex;
    align-self: flex-end;
    align-items: flex-end;
    justify-content: flex-end;
    flex-wrap: wrap;
    flex-direction: column;

    &__avatar {
        width: size(lg);
        height: size(lg);
        padding: 0 size(sm);
    }

    &__content-container {
        display: flex;
        align-items: flex-end;
        width: max-content;
        max-width: 100%;
    }

    &__avatar {
        width: size(lg);
        height: size(lg);
        padding: 0 size(sm);
        border-radius: 50%;

        &__skeleton {
            border-radius: 50%;
            background-color: var(--theme-colors-default--gray-200);
            width: size(xl);
            height: size(xl);
        }
    }

    &__content {
        width: calc(100% - 50px);
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: size(sm);

        & > div {
            padding: size(md);
            border-radius: size(sm);
            box-sizing: border-box;
            background-color: #DDE8F7;
            color: var(--theme-colors-default--gray-700);
            border-bottom: 1px solid var(--theme-colors-default--gray-300);
            box-shadow: 0 0 5px 0 rgba(0,0,0,0.15);
            font-size: font-size(sm);
            line-height: 19px;
        }
    }

    &__footer {
        padding-top: 5px;
        padding-right: 50px;
    }
}

.chat-assistent-interaction-item__content--heyloha {
    & > div {
        background-color: #FAD5CD;
    }
}
</style>
